// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1AtdA","inputWrap":"Table_inputWrap__2oyOy","col":"Table_col__236IM","bmiTooltip":"Table_bmiTooltip__2svTj"};